export default import.meta.ROLLDOWN_FILE_URL_PzGNosqhvg0cqZPyiex3Ag